/**
 * Auth session flag (UI/app state only — NOT server data).
 *
 * `status` mirrors whether an access token is currently held. The actual user
 * record is server data fetched via `useCurrentUser` (TanStack Query), per the
 * "Zustand for UI state only" rule.
 */

import { create } from "zustand";

export type AuthStatus = "anonymous" | "authenticated";

interface AuthState {
  status: AuthStatus;
  setAuthenticated: () => void;
  setAnonymous: () => void;
}

export const useAuthStore = create<AuthState>((set) => ({
  status: "anonymous",
  setAuthenticated: () => set({ status: "authenticated" }),
  setAnonymous: () => set({ status: "anonymous" }),
}));
